import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DealerAccessoriesComponent} from './dealer-accessories.component';
import {TranslateModule} from '@ox/translate';
import {DrawerModalModule} from '@ox/ui';
import {TrackingModule} from '@ox/data';
import {DealerWebuModule} from '../../dealer';
import {LoadingModule} from '@ox/ui';

@NgModule({
    declarations: [DealerAccessoriesComponent],
    imports: [
        CommonModule, 
        TranslateModule,
        TrackingModule,
        DrawerModalModule,
        DealerWebuModule,
        LoadingModule
    ],
    exports: [DealerAccessoriesComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DealerAccessoriesModule {}

export const DEALER_ACCESSORIES_ROUTES = [
    {
        path: '',
        component: DealerAccessoriesComponent,
        outlet: 'webu-dealer-accessories'
    }
];